var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "firmware-list" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "primary",
                size: "14",
              },
              on: { click: _vm.handleAssociatedFirmware },
            },
            [_vm._v("关联固件")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "add",
                size: "14",
                icon: "el-icon-plus",
              },
              on: { click: _vm.handleAddFirmware },
            },
            [_vm._v("新建固件")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "firmwareKey", label: "固件Key" },
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "固件名称" } }),
          _c("el-table-column", {
            attrs: { prop: "componentTypeName", label: "固件类型" },
          }),
          _c("el-table-column", {
            attrs: { prop: "version", label: "固件版本" },
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "固件版本状态", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.state === 0
                      ? _c("span", [_vm._v("未上架")])
                      : _vm._e(),
                    scope.row.state === 1
                      ? _c("span", [_vm._v("已上架")])
                      : _vm._e(),
                    scope.row.state === 2
                      ? _c("span", [_vm._v("不存在")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "customNumber", label: "自定义编号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "releaseStatus", label: "检查更新" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.releaseStatus
                      ? _c("span", [_vm._v("已开启")])
                      : _c("span", [_vm._v("已关闭")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "版本说明" },
          }),
          _c("el-table-column", {
            attrs: { prop: "fileName", label: "文件名称" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "500" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: _vm.rolesCode === "SALE",
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleChangeVersion(scope.row)
                          },
                        },
                      },
                      [_vm._v("变更版本")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: scope.row.state === 2,
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.jumpDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.rolesCode === "SALE" || scope.row.state === 2,
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleRelease(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            scope.row.releaseStatus
                              ? "关闭检查更新"
                              : "开启检查更新"
                          )
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.rolesCode === "SALE" || scope.row.state === 2,
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleTask(scope.row, 1)
                          },
                        },
                      },
                      [_vm._v("测试任务")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.rolesCode === "SALE" || scope.row.state === 2,
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleTask(scope.row, 2)
                          },
                        },
                      },
                      [_vm._v("升级任务")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.rolesCode === "SALE" || scope.row.state === 2,
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleUnbind(scope.row)
                          },
                        },
                      },
                      [_vm._v("解除绑定")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.current,
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("addFirmwareDialog", {
        ref: "addFirmware",
        attrs: {
          "product-id": _vm.productId,
          "page-type": "firmwareDetails",
          "get-firmware-list": _vm.getFirmwareList,
        },
        on: { close: _vm.handleClose },
      }),
      _c("associatedFirmwareDialog", {
        ref: "associatedFirmware",
        attrs: {
          "product-id": _vm.productId,
          "product-name": _vm.form.productName,
          "get-firmware-list": _vm.getFirmwareList,
        },
        on: { close: _vm.handleClose },
      }),
      _c("changeVersionDialog", {
        ref: "changeVersion",
        attrs: {
          "change-version-rows": _vm.changeVersionRows,
          "change-version-key": _vm.changeVersionKey,
          "get-firmware-list": _vm.getFirmwareList,
        },
        on: { close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }